<template>
  <div class="mb-4">
    <h6 class="mb-0">Categorias</h6>
    <div class="categories-container">
      <!-- Categorias -->
      <div
        v-for="category in categories"
        :key="category.id"
        @click="selectCategory(category.id)"
      >
        <v-hover v-slot="{ hover }">
          <div
            class="category-item"
            :class="{ selected: selectedCategory === category.id }"
          >
            <div class="category-circle" style="position: relative">
              <v-img
                v-if="isImageUrl(category.icon)"
                :src="category.icon"
                :alt="category.name"
                class="category-image"
              />
              <v-icon v-else-if="category.icon" class="category-icon">
                {{ category.icon }}
              </v-icon>
              <span v-else class="category-initial">
                {{ getInitial(category.name) }}
              </span>
              <v-overlay
                :value="selectedCategory === category.id"
                absolute
                color="primary"
                opacity="0.7"
              >
                <v-icon v-if="!hover">mdi-check</v-icon>
                <v-icon v-else>mdi-close</v-icon>
              </v-overlay>
            </div>
            <span class="category-name px-1 unselectable">{{
              category.name
            }}</span>
          </div>
        </v-hover>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryFilter",
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    selectedCategory: {
      type: String,
      default: null,
    },
  },
  methods: {
    selectCategory(categoryId) {
      if (this.selectedCategory === categoryId)
        this.$emit("category-selected", null);
      else this.$emit("category-selected", categoryId);
    },
    getInitial(name) {
      return name.charAt(0).toUpperCase();
    },
    isImageUrl(icon) {
      return icon && (icon.startsWith("http") || icon.startsWith("data:image"));
    },
  },
};
</script>

<style scoped>
.categories-container {
  display: flex;
  gap: 2rem;
  overflow-x: auto;
  padding: 0.5rem 0;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.categories-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.category-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 100px;
  padding: 0.5rem;
  border-radius: 12px;
}

.category-item.selected {
  transform: none;
}

.category-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.category-circle::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.05) 100%
  );
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.category-item:hover .category-circle::before {
  opacity: 1;
}

.category-item.selected .category-circle {
  transform: scale(1.2);
}

.category-item.selected .category-circle::after {
  content: "";
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
  border-radius: 50%;
  z-index: -1;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.6);
    opacity: 0.4;
  }
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
}

.category-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  z-index: 1;
}

.category-icon {
  color: white;
  font-size: 28px;
  z-index: 1;
}

.category-initial {
  color: white;
  font-size: 24px;
  font-weight: 600;
  z-index: 1;
  text-transform: uppercase;
}

.category-name {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  line-height: 1.2;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Responsividade */
@media (max-width: 768px) {
  .category-circle {
    width: 70px;
    height: 70px;
  }

  .category-icon {
    font-size: 24px;
  }

  .category-initial {
    font-size: 20px;
  }

  .category-name {
    font-size: 14px;
  }

  .categories-container {
    gap: 1.5rem;
  }

  .category-item {
    min-width: 90px;
  }
}

@media (max-width: 480px) {
  .category-circle {
    width: 60px;
    height: 60px;
  }

  .category-icon {
    font-size: 20px;
  }

  .category-initial {
    font-size: 18px;
  }

  .category-name {
    font-size: 13px;
  }

  .categories-container {
    gap: 1rem;
  }

  .category-item {
    min-width: 80px;
  }
}
</style>
